import React, { useRef, useState } from 'react'
import styles from './styles.module.scss'
import { selectArrow } from '../svg/dashboard/main'


export const Select = ({children, onChange, ...props}) => {
  const selectRef = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    if (selectRef.current) {
      selectRef.current.focus()
      selectRef.current.click()
    }
  }

  const handleMouseDown = () => {
    setIsOpen(!isOpen)
  }

  const handleBlur = () => {
    setIsOpen(false)
  }

  const onChangeHandler = (e) => {
    onChange(e)
    setIsOpen(false)
  }

  return (
    <div className={styles.select} onClick={handleClick}>
      <select 
        ref={selectRef} 
        {...props}
        onMouseDown={handleMouseDown}
        onBlur={handleBlur}
        onChange={onChangeHandler}
      >
        {children}
      </select>
      <div className={`${styles.arrow} ${isOpen ? styles.open : ''}`}>
        {selectArrow}
      </div>
    </div>
  )
}
